<template>
  <v-container align-content-center fill-height fluid>
    <v-row v-if="logo" justify="center">
      <img :src="logo" />
    </v-row>
    <v-row justify="center">
      <slot></slot>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    logo: String
  }
}
</script>
